import React from "react";
import ClaimButton from "@components/FlowActionButtons/ClaimButton";
import type { VendorLicenseTask } from "@services/licensing/types";
import { useClaimLicense } from "./hooks";
import { canUserClaim } from "./utils";

type LicenseFlowData = {
  id: string;
  status: string;
  task: VendorLicenseTask | null;
};

interface ClaimLicenseProps {
  refetchLicense: () => Promise<unknown> | void;
  licenseFlowData?: LicenseFlowData;
  isPortOperatorContext?: boolean;
}

const LANG_BASE = "licensing";

const ClaimLicense: React.FC<ClaimLicenseProps> = ({
  licenseFlowData,
  refetchLicense,
  isPortOperatorContext = false,
}) => {
  const { onClaimLicense } = useClaimLicense(
    licenseFlowData?.id,
    refetchLicense,
    isPortOperatorContext,
  );

  if (!licenseFlowData || !licenseFlowData.task) return null;

  const isActionAvailable = canUserClaim(licenseFlowData.task.status, licenseFlowData.status);

  return (
    <ClaimButton
      langBase={LANG_BASE}
      permission={["canClaimPortOperatorLicense", "canClaimVendorLicense"]}
      isActionAvailable={isActionAvailable}
      onClaim={onClaimLicense}
    />
  );
};

export default ClaimLicense;
